import { Component, Input } from '@angular/core';
import { ComplianceData } from '../../shared/models/compliance-data.model';
import { BASIC_IMPORTS } from '../../shared/imports/common-imports';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-ta-overview',
  standalone: true,
  imports: [BASIC_IMPORTS, RouterLink],
  templateUrl: './ta-overview.component.html',
  styleUrl: './ta-overview.component.scss',
})
export class TaOverviewComponent {
  @Input() data!: ComplianceData;
}
